export default __webpack_public_path__ + "static/media/left_content_1.85c72e0d.svg";